import React, { useEffect, useState } from "react";
import { countdownParts } from "@/lib/format";

export default function Countdown({ target, compact = false, onExpire }) {
  const [parts, setParts] = useState(() => countdownParts(target));

  useEffect(() => {
    const t = setInterval(() => {
      const p = countdownParts(target);
      setParts(p);
      if (!p && onExpire) onExpire();
    }, 1000);
    return () => clearInterval(t);
  }, [target, onExpire]);

  if (!parts) return <span className="font-mono-ui text-status-locked">00:00:00</span>;

  const pad = (n) => String(n).padStart(2, "0");
  if (compact) {
    const str = parts.d > 0 ? `${parts.d}g ${pad(parts.h)}h` : `${pad(parts.h)}:${pad(parts.m)}:${pad(parts.s)}`;
    return <span className="font-mono-ui">{str}</span>;
  }
  const Box = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <div className="surface-elevated font-mono-ui text-2xl md:text-3xl font-bold text-gold-300 px-3 py-2 min-w-[3.2rem] text-center">{pad(v)}</div>
      <span className="text-[0.6rem] uppercase tracking-widest text-muted-foreground mt-1">{l}</span>
    </div>
  );
  return (
    <div className="flex items-center gap-2 md:gap-3">
      <Box v={parts.d} l="Giorni" /><Box v={parts.h} l="Ore" /><Box v={parts.m} l="Min" /><Box v={parts.s} l="Sec" />
    </div>
  );
}
